import React from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import firebase from "firebase"
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import {
  BrowserRouter as Router
} from "react-router-dom";
import API from './API';
const SafeGuardApi = new API();


function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - base64String.length % 4) % 4)
  const base64 = (base64String + padding).replace(/\-/g, "+").replace(/_/g, "/")

  const rawData = window.atob(base64)
  const outputArray = new Uint8Array(rawData.length)

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i)
  }
  return outputArray
}

const vapidPublicKey =  "BIOiSv1BjSlUvyidgBVlqln4lfRNW7VWj8PrwGKmnboV0xQw15kyRzgkdqfLMFHMp1rzOAxoSInwuu8A8h3DYGA";
const convertedVapidKey = urlBase64ToUint8Array(vapidPublicKey);

var config = {
  apiKey: "AIzaSyCY-kWbdGco6PxmqVYs7t3-hkC-aOSwBds",
  authDomain: "forest-log-book.firebaseapp.com",
  databaseURL: "https://forest-log-book.firebaseio.com",
  projectId: "forest-log-book",
  storageBucket: "forest-log-book.appspot.com",
  messagingSenderId: "965384475774",
  appId: "1:965384475774:web:eaaa0c699968bc380db42f"
};
 firebase.initializeApp(config);
const messaging = firebase.messaging();

function handleMessageFromWorker(msg) {
  console.log("Message from worker:" );
  console.log(msg);
  getLocation();
}



function saveWorkerLocation(position){

  const base_url = "https://forestlogbook.herokuapp.com/";
  let client = axios.create({ withCredentials: true },{ credentials: "include", crossdomain: true});
  let locationToSend = {location:{latitude:position.coords.latitude,longitude:position.coords.longitude}};
  client.post(base_url +"api/saveWorkerLocation",locationToSend,{headers: {"WorkerAccessToken": (window.localStorage.accessToken)}})
  .then(
    (result) => {
      
    },

    (error) => {
      
  
  }
  );
}
function getLocation() {
  if (navigator.geolocation) {
    
    window.navigator.vibrate(2000);
    navigator.geolocation.getCurrentPosition(saveWorkerLocation);
  }
}



messaging.usePublicVapidKey(vapidPublicKey);

messaging.onTokenRefresh(function() {
  messaging.getToken()
  .then(function(refreshedToken) {
    console.log('Token refreshed.');
    // Indicate that the new Instance ID token has not yet been sent to the
    // app server.
    window.setTokenSentToServer(false);
    // Send Instance ID token to app server.
    window.sendTokenToServer(refreshedToken);
    // [START_EXCLUDE]
    // Display new Instance ID token and clear UI of all previous messages.
    resetUI();
    // [END_EXCLUDE]
  })
  .catch(function(err) {
    console.log('Unable to retrieve refreshed token ', err);
    showToken('Unable to retrieve refreshed token ', err);
  });
});
// [END refresh_token]
// [START receive_message]
// Handle incoming messages. Called when:
// - a message is received while the app has focus
// - the user clicks on an app notification created by a sevice worker
//   `messaging.setBackgroundMessageHandler` handler.
messaging.onMessage(function(payload) {
 
    console.log("Message received. ", payload);
  // [START_EXCLUDE]
  // Update the UI to include the received message.
 
  // [END_EXCLUDE]
});
// [END receive_message]
function resetUI() {

  // [START get_token]
  // Get Instance ID token. Initially this makes a network call, once retrieved
  // subsequent calls to getToken will return from cache.
  messaging.getToken()
  .then(function(currentToken) {
    if (currentToken) {
      window.sendTokenToServer(currentToken);

    } else {
      // Show permission request.
      console.log('No Instance ID token available. Request permission to generate one.');
      requestPermission();
      window.setTokenSentToServer(false);
    }
  })
  .catch(function(err) {
 
    showToken('Error retrieving Instance ID token. ', err);
    window.setTokenSentToServer(false);
  });
}
// [END get_token]
function showToken(currentToken) {
  // Show token in console and UI.
  
  // var tokenElement = document.querySelector('#token');
  // tokenElement.textContent = currentToken;
}

function requestPermission() {
  console.log('Requesting permission...');
  // [START request_permission]
  messaging.requestPermission()
  .then(function() {
    console.log('Notification permission granted.');
    // TODO(developer): Retrieve an Instance ID token for use with FCM.
    // [START_EXCLUDE]
    // In many cases once an app has been granted notification permission, it
    // should update its UI reflecting this.
    resetUI();
    // [END_EXCLUDE]
  })
  .catch(function(err) {
    console.log('Unable to get permission to notify.', err);
  });
  // [END request_permission]
}
// Send the Instance ID token your application server, so that it can:
// - send messages back to this app
// - subscribe/unsubscribe the token from topics
window.sendTokenToServer = function(currentToken) {
  console.log(currentToken);
  window.localStorage.userMessagingToken = currentToken;
  //if (!isTokenSentToServer()) {
    console.log('Sending token to server...');
    // TODO(developer): Send the current token to your server.
    axios.post("https://forestlogbook.herokuapp.com/api/subscribe", currentToken)

    window.setTokenSentToServer(true);
  /*} else {
    console.log('Token already sent to server so won\'t send it again ' +
        'unless it changes');
  }*/
}
function isTokenSentToServer() {
  if (window.localStorage.getItem('sentToServer') == 1) {
        return true;
  }
  return false;
}
window.setTokenSentToServer = function (sent) {
  window.localStorage.setItem('sentToServer', sent ? 1 : 0);
}



ReactDOM.render(
  <React.StrictMode>
     <Router>
    <App />

     </Router>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
resetUI();

window.addEventListener('message', function(event) {
  console.log("Test");
  getLocation();
});

